import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex flex-col gap-4"
}
const _hoisted_2 = { class: "flex flex-col md:flex-row gap-4" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-x-4 gap-y-2 text-left text-sm text-textPrimary" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Empresa", -1)
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Escala", -1)
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Unidade", -1)
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Posição", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-textPrimary mb-2" }, "Opções de remoção", -1)
const _hoisted_13 = { class: "flex flex-col gap-6" }
const _hoisted_14 = { class: "flex flex-col gap-2" }
const _hoisted_15 = { class: "text-left text-sm text-[#68688D]" }
const _hoisted_16 = {
  key: 0,
  class: "flex flex-col gap-6"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-textPrimary mb-4" }, "Abrangência", -1)
const _hoisted_18 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6" }
const _hoisted_19 = { class: "mt-4 flex items-start gap-2 p-3 rounded-md bg-primary/5 border border-primary/20" }
const _hoisted_20 = { class: "text-sm text-textPrimary" }
const _hoisted_21 = { class: "font-semibold" }
const _hoisted_22 = { class: "flex w-full gap-4" }
const _hoisted_23 = {
  key: 0,
  class: "w-1/4"
}
const _hoisted_24 = { key: 2 }
const _hoisted_25 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_26 = {
  class: "text-sm text-left text-textPrimary",
  "data-testid": "remove-doctor-summary"
}
const _hoisted_27 = {
  key: 1,
  class: "flex flex-col gap-4 mt-4"
}
const _hoisted_28 = {
  key: 1,
  class: "flex flex-col items-center justify-center text-center py-10"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-gray-600" }, " Nenhum plantão encontrado com os parâmetros selecionados. ", -1)
const _hoisted_30 = { class: "p-4" }
const _hoisted_31 = {
  key: 0,
  class: "flex flex-col-reverse md:flex-row gap-3 justify-between w-full"
}
const _hoisted_32 = {
  key: 0,
  class: "flex flex-col-reverse md:flex-row gap-3 justify-between w-full"
}
const _hoisted_33 = {
  key: 1,
  class: "flex justify-center w-full"
}

import { ref, computed, PropType, watch, toRef } from 'vue'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import { DatePicker } from 'v-calendar'
import { endOfDay, format } from 'date-fns'
import 'v-calendar/style.css'
import { mdiAlertCircleOutline, mdiCalendar, mdiInformationOutline } from '@mdi/js'
import StationService from '@/Network/Services/StationService'
import { ShiftDetails, StationFormSchedule } from '@/Network/Types/Responses/StationResponses'
import {
  ListStationsFromScheduleRequest,
  PatchStationsFromSchedulePayload,
  StationTypes
} from '@/Network/Types/Requests/StationRequests'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import CardDutyWithDoctor from '@/components/designSystem/Cards/CardDutyWithDoctor.vue'
import ManagementDoctorTable from '../../components/ManagementDoctorTable.vue'
import ExpandedTableModal from '../../components/ExpandedTableModal.vue'
import CoveragePreviewSummary from '../../components/CoveragePreviewSummary.vue'
import SelectableCard from '@/components/designSystem/Cards/SelectableCard.vue'
import OptionSelect from '@/components/designSystem/Select/OptionSelect.vue'
import Spinner from '@/components/others/Spinner.vue'
import {
  dayOptions,
  repetition,
  weekOptions,
  removeRecurrenceOptions,
  removePeriodicityOptions,
  removeTableHeaders,
  dayMapping,
  weekMapping
} from '../utils/data'
import { useStationStore } from '@/pinia-store/useStationStore'
import {
  useExpandedTable,
  useFormattedShifts,
  useInitialPage,
  useSummaryText
} from '../utils/modalUtils'
import ActionModalHeader from '../../components/ActionModalHeader.vue'
import {
  getPostStationApprovedMessage,
  isPostStationApprovedError
} from '@/modules/company/PostStation/errors'
import CoverageModeSelector from '@/components/Coverage/CoverageModeSelector.vue'
import { useUnidentifiedCoverageLock } from '@/components/Coverage/useUnidentifiedCoverageLock'
import CoverageResponsibleField from '@/components/Coverage/CoverageResponsibleField.vue'
import CoverageTransitionConfirmModal from '@/components/Coverage/CoverageTransitionConfirmModal.vue'
import UnidentifiedCoverageCard from '@/components/Coverage/UnidentifiedCoverageCard.vue'
import { CoverageMode } from '@/Network/Types/Requests/CoverageRequests'
import {
  canMarkUnidentified,
  getStationCoverageInfo,
  scheduleSupportsCoverage
} from '@/utils/coverage'
import { getCoverageErrorMessage } from '@/utils/coverageErrors'
import ChangeReasonField from '@/components/ChangeReason/ChangeReasonField.vue'
import { useChangeReasonForm } from '@/composables/useChangeReasonForm'
import {
  CHANGE_REASON_LABELS,
  CHANGE_REASON_TITLES,
  EXTERNAL_REASON_OPTIONS,
  changeReasonScopeNote,
  isEarlyWithdrawalWindow,
  removalReasonOptions,
  stationStartsAt
} from '@/utils/changeReasons'
import {
  buildCoverageOperations,
  buildCoveragePatchStations,
  buildCoveragePlan,
  buildTransitionSummary,
  coverageTableHeaders,
  needsTransitionConfirmation,
  toPreviewTableRow
} from '../utils/coverageAllocation'
import { requiredReasonKinds } from '../utils/changeReasonPlan'


export default /*#__PURE__*/_defineComponent({
  __name: 'remove.doctor.modal',
  props: {
  showModal: {
    type: Boolean,
    required: true
  },
  stationDetails: {
    type: Object as PropType<ShiftDetails | null>,
    default: () => null
  },
  // "Liberar vaga" (M7-B): parte de um plantão ocupado sem identificação e volta a vaga aberta.
  release: {
    type: Boolean,
    default: false
  }
},
  emits: ['closeModal', 'removalUpdated'],
  setup(__props, { emit }) {

const props = __props;




const toast = useToast()
const { notifyError } = useErrorToast()
const stationService = new StationService()
const stationStore = useStationStore()

const isThisModalVisible = ref(props.showModal)
const isExpandedTableModalOpen = ref(false)
const selectedPeriodicity = ref<number | null>(2)
const showShiftList = ref(false)
const isLoading = ref(false)
const selectedRecurrence = ref('once')
const selectedWeeks = ref(['A', 'C'])
const selectedDay = ref(['seg'])
const startDate = ref()
const selectedRepetition = ref('end_scale')

const shifts = ref<StationFormSchedule[]>([])
const isLoadingShifts = ref(false)
const isLoadingSubmit = ref(false)
const totalShiftsCount = ref(0)
const conflictShiftsCount = ref(0)
const openShiftsCount = ref(0)
const closedShiftsCount = ref(0)
// `countUnregistered` do BE: ocupado sem identificação saiu de `countOpen` (null = BE antigo).
const unregisteredShiftsCount = ref<number | null>(null)

const replacement = ref<CoverageMode>(CoverageMode.OPEN)
const coverageResponsibleId = ref<number | null>(null)
const coverageNote = ref('')
const selectedResponsibleName = ref<string | null>(null)
const isTransitionModalOpen = ref(false)

const scheduleSupports = computed(() => scheduleSupportsCoverage(props.stationDetails?.schedule))
const allowUnidentified = computed(() => canMarkUnidentified(props.stationDetails?.schedule))
const { unidentifiedLocked, canOpenScheduleSettings, openScheduleSettings } =
  useUnidentifiedCoverageLock(() => props.stationDetails?.schedule)
const originCoverage = computed(() => getStationCoverageInfo(props.stationDetails))
const target = computed(() => (props.release ? CoverageMode.OPEN : replacement.value))
const coveragePlan = computed(() =>
  buildCoveragePlan(shifts.value, target.value, {
    scope: props.release ? 'unidentifiedOnly' : 'doctorOnly'
  })
)
const reasonCount = computed(() => coveragePlan.value.applicableRows.length)
const reasonScopeNote = computed(() => changeReasonScopeNote(reasonCount.value, 'da tabela'))
const {
  values: reasonValues,
  showErrors: showReasonErrors,
  fields: reasonFields,
  reset: resetReasons,
  validate: validateReasons,
  build: buildReasons
} = useChangeReasonForm(() =>
  requiredReasonKinds(coveragePlan.value, { targetDoctorId: null, externalTeam: false }).map(
    (kind) =>
      kind === 'removal'
        ? {
            kind,
            title: props.release
              ? CHANGE_REASON_TITLES.release(reasonCount.value)
              : CHANGE_REASON_TITLES.removal(reasonCount.value),
            label: CHANGE_REASON_LABELS.removal,
            options: removalReasonOptions({
              // `startHour` do GET /stations/:id é ISO com offset: o instante do plantão clicado.
              earlyWithdrawal: isEarlyWithdrawalWindow(stationStartsAt(props.stationDetails)),
              // O substituto aqui nunca é médico interno (vaga aberta ou sem identificação).
              offAppSwap: false
            })
          }
        : {
            kind,
            title: CHANGE_REASON_TITLES.external(reasonCount.value),
            label: CHANGE_REASON_LABELS.external,
            options: EXTERNAL_REASON_OPTIONS
          }
  )
)
const transitionSummary = computed(() => buildTransitionSummary(coveragePlan.value))
const previewHeaders = computed(() =>
  coveragePlan.value.hasContract ? coverageTableHeaders : removeTableHeaders
)
// Com contrato e nenhuma linha aplicável (todas bloqueadas) não há o que enviar (M6-C).
const isSubmitBlocked = computed(
  () => coveragePlan.value.hasContract && coveragePlan.value.applicableRows.length === 0
)
const confirmLabel = computed(() => {
  if (props.release) return 'Confirmar liberação'
  // M4: com a prévia de cobertura o botão diz em quantos plantões vai aplicar.
  if (coveragePlan.value.hasContract) {
    const n = coveragePlan.value.applicableRows.length
    return n > 0 ? `Aplicar em ${n} ${n === 1 ? 'plantão' : 'plantões'}` : 'Aplicar'
  }
  return needsTransitionConfirmation(coveragePlan.value) ? 'Continuar' : 'Confirmar remoção'
})

const { handleExpandTable, handleCloseExpandedTable } = useExpandedTable(
  isThisModalVisible,
  isExpandedTableModalOpen
)

const recurrenceDescription = computed(() => {
  const selected = removeRecurrenceOptions.find((opt) => opt.value === selectedRecurrence.value)
  return selected ? selected.description : ''
})

const formattedStartDate = computed(() => {
  if (props.stationDetails && props.stationDetails.startHour) {
    try {
      return format(new Date(props.stationDetails.startHour), 'dd/MM/yyyy')
    } catch (e) {
      return ''
    }
  }
  return ''
})

const isViewShiftsButtonEnabled = computed(() => {
  if (target.value === CoverageMode.UNIDENTIFIED && !coverageResponsibleId.value) return false
  if (selectedRecurrence.value === 'once') {
    return true
  }
  return !!selectedPeriodicity.value && !!selectedRecurrence.value && selectedDay.value.length > 0
})

const ALL_BLOCKED_MESSAGES: Record<CoverageMode, string> = {
  [CoverageMode.DOCTOR]:
    'Nenhum plantão pode ser alterado: todos os selecionados estão bloqueados.',
  [CoverageMode.UNIDENTIFIED]:
    'Nenhum plantão pode ser marcado como ocupado sem identificação: todos os selecionados estão bloqueados.',
  [CoverageMode.OPEN]:
    'Nenhum plantão pode ser liberado como vaga aberta: todos os selecionados estão bloqueados.'
}

const doctorNameToUse = computed(() => props.stationDetails?.doctorStation?.doctor?.user?.name)
const summaryText = computed(() => {
  const n = coveragePlan.value.applicableRows.length
  const noun = n === 1 ? 'plantão' : 'plantões'
  if (coveragePlan.value.hasContract && n === 0 && coveragePlan.value.counts.BLOCKED > 0)
    return ALL_BLOCKED_MESSAGES[target.value]
  if (props.release)
    return `Você está liberando ${n} ${noun} ocupado(s) sem identificação. Eles voltam a ser vaga aberta.`
  if (target.value === CoverageMode.UNIDENTIFIED)
    return `Você está trocando o médico por "Ocupado sem identificação" em ${n} ${noun}. Deseja continuar?`
  return useSummaryText(doctorNameToUse, totalShiftsCount, 'remove')
})

const legacyFormattedShifts = useFormattedShifts(shifts, 'remove')
const formattedShifts = computed(() =>
  coveragePlan.value.hasContract
    ? coveragePlan.value.rows.map(toPreviewTableRow)
    : legacyFormattedShifts.value
)

const limitedFormattedShifts = computed(() => formattedShifts.value.slice(0, 9))

const initialPage = useInitialPage(toRef(props, 'stationDetails'))

const initializeDefaults = () => {
  let defaultDay = 'seg'
  let defaultWeek = 'A'

  if (props.stationDetails && props.stationDetails.startHour) {
    try {
      const date = new Date(props.stationDetails.startHour)
      if (!isNaN(date.getTime())) {
        const dayIndex = date.getDay()
        const foundKey = (Object.keys(dayMapping) as Array<keyof typeof dayMapping>).find(
          (key) => dayMapping[key] === dayIndex
        )
        if (foundKey) {
          defaultDay = String(foundKey)
        }

        const dayOfMonth = date.getDate()
        const weekIndex = Math.floor((dayOfMonth - 1) / 7)
        const weekLetters = ['A', 'B', 'C', 'D', 'E']
        if (weekIndex >= 0 && weekIndex < weekLetters.length) {
          defaultWeek = weekLetters[weekIndex]
        }
      }
    } catch (e) {
      // fallback intencional: erro local (parse de data), não de API — o formulário segue
      // com o padrão seg/semana A, visível nos seletores de dia e de semana.
      console.error('Erro ao calcular data padrão da station:', e)
    }
  }

  selectedWeeks.value = [defaultWeek]
  selectedDay.value = [defaultDay]
}

// eslint-disable-next-line complexity
const buildDoctorStationsFilters = (): ListStationsFromScheduleRequest | null => {
  if (!props.stationDetails?.schedule?.id) return null
  // Backend com a feature recebe o alvo da cobertura para calcular bloqueios do preview
  // (ex.: ANTECIPE ao trocar o médico por "Ocupado sem identificação").
  const coverageFilter = scheduleSupports.value ? { coverage: target.value } : {}

  if (selectedRecurrence.value === 'once') {
    return {
      schedule: props.stationDetails.schedule.id,
      station: props.stationDetails.id,
      ...coverageFilter
    }
  }

  const sDate = new Date(props.stationDetails.startHour)
  let eDate: Date | undefined

  if (selectedRepetition.value === 'personalized' && startDate.value) {
    eDate = endOfDay(startDate.value)
  }

  if (selectedRepetition.value === 'end_scale' && props.stationDetails.schedule.endDate) {
    eDate = new Date(props.stationDetails.schedule.endDate)
  }

  const weekDays = selectedDay.value.map((day) => dayMapping[day]).join(',')

  let weekOfMonth = '0,1,2,3,4,5'

  let fortnightlyFilters = {}
  if (selectedRecurrence.value === 'fortnightly') {
    fortnightlyFilters = {
      alternatingWeek: true,
      stationWeekParity: props.stationDetails.stationWeekParity
    }
  }

  if (selectedRecurrence.value === 'abcde') {
    weekOfMonth = selectedWeeks.value.map((week) => weekMapping[week]).join(',')
  }

  const filters: ListStationsFromScheduleRequest = {
    schedule: props.stationDetails.schedule.id,
    startDate: sDate.toISOString(),
    weekDays: weekDays,
    weekOfMonth: weekOfMonth,
    ...fortnightlyFilters
  }

  if (selectedPeriodicity.value === 1 && props.stationDetails?.doctorStation?.doctor?.id) {
    filters.doctorStationPackage = props.stationDetails.doctorStation?.package?.id
  }

  if (selectedPeriodicity.value === 2) {
    filters.position = props.stationDetails.position.id
    filters.shifts = [props.stationDetails.shift.id].join(',')
  }

  if (eDate) {
    filters.endDate = eDate.toISOString()
  }

  return { ...filters, ...coverageFilter }
}

async function handleViewDoctorStations() {
  const baseFilters = buildDoctorStationsFilters()
  if (!baseFilters) {
    toast.error('Detalhes da escala não encontrados para buscar os plantões.')
    return
  }

  isLoadingShifts.value = true
  shifts.value = []
  try {
    const response = await stationService.listStationsFromSchedule({
      ...baseFilters,
      excludeHasCheckIn: true
    })

    shifts.value = response.stations
    totalShiftsCount.value = response.count
    openShiftsCount.value = response.countOpen
    conflictShiftsCount.value = response.countConflict
    closedShiftsCount.value = response.countClosed
    unregisteredShiftsCount.value = response.countUnregistered ?? null
    showShiftList.value = true
  } catch (error) {
    notifyError(error, 'Não foi possível carregar a lista de plantões')
    console.error(error)
  } finally {
    isLoadingShifts.value = false
  }
}

async function submitRemoveDoctor() {
  if (!validateReasons()) return
  // M6: médico real → sem identificação passa pela confirmação antes de gravar.
  if (needsTransitionConfirmation(coveragePlan.value)) {
    isTransitionModalOpen.value = true
    return
  }
  await executeRemoval()
}

async function handleTransitionConfirm() {
  // M6 só fecha no sucesso: se o PATCH falhar, o usuário continua na confirmação (com o toast de erro).
  const succeeded = await executeRemoval()
  if (succeeded) isTransitionModalOpen.value = false
}

// eslint-disable-next-line complexity
async function executeRemoval(): Promise<boolean> {
  isLoadingSubmit.value = true
  try {
    const plan = coveragePlan.value
    const operations = buildCoverageOperations(plan, {
      fallbackOriginDoctorId: props.stationDetails?.doctorStation?.doctor?.id ?? null,
      packageId: props.stationDetails?.doctorStation?.package?.id ?? null
    })
    if (shifts.value.length === 0 || operations.length === 0) {
      toast.error('Nenhum plantão selecionado para remoção.')
      return false
    }

    const changeReasons = buildReasons({ originStationId: props.stationDetails?.id ?? null })
    const payload: PatchStationsFromSchedulePayload = {
      operations,
      patchStations: buildCoveragePatchStations({
        target: target.value,
        hasContract: plan.hasContract,
        doctorId: null,
        ourTeam: false,
        userSponsorId: null,
        formationId: null,
        stationType:
          (props.stationDetails?.doctorStation?.type as StationTypes | undefined) ?? null,
        responsibleId: coverageResponsibleId.value,
        note: coverageNote.value
      }),
      scheduleId: Number(props.stationDetails?.schedule?.id),
      ...(changeReasons ? { changeReasons } : {})
    }

    await stationService.patchStationsFromSchedule(payload)

    toast.success(
      props.release
        ? 'Vaga liberada com sucesso!'
        : target.value === CoverageMode.UNIDENTIFIED
          ? 'Plantões marcados como ocupados sem identificação.'
          : 'Remoção confirmada com sucesso!'
    )
    emit('removalUpdated')
    close()
    await stationStore.getListStations()
    return true
  } catch (error) {
    console.error('Erro ao submeter a remoção:', error)

    // Defesa em profundidade (RN-07 / RF-12): o botão que abre este modal já
    // vem desabilitado num plantão aprovado, mas a varredura pode aprovar
    // enquanto o modal está aberto. Sem este ramo o 400 do backend aparecia
    // como "Erro ao confirmar a remoção.", que não diz o que fazer. O backend
    // manda a frase pronta em pt-BR — repassar em vez de reescrever.
    if (isPostStationApprovedError(error)) {
      toast.error(getPostStationApprovedMessage(error))
      return false
    }

    // Códigos de cobertura (Antecipe, check-in, flag desligada…) viram a frase do catálogo;
    // demais erros seguem o toast genérico (antes: "Erro ao confirmar a remoção." estático).
    const coverageMessage = getCoverageErrorMessage(error)
    if (coverageMessage) {
      toast.error(coverageMessage)
    } else {
      notifyError(error, 'Não foi possível confirmar a remoção')
    }
    return false
  } finally {
    isLoadingSubmit.value = false
  }
}

function close() {
  emit('closeModal')
}

watch(
  () => props.stationDetails,
  (newDetails) => {
    if (newDetails && props.showModal) {
      initializeDefaults()
    }
  },
  { immediate: true, deep: true }
)

watch(
  () => props.showModal,
  (newValue) => {
    isThisModalVisible.value = newValue
    showShiftList.value = false
    shifts.value = []
    totalShiftsCount.value = 0
    openShiftsCount.value = 0
    closedShiftsCount.value = 0

    if (newValue) {
      initializeDefaults()
      selectedPeriodicity.value = 2
      selectedRepetition.value = 'end_scale'
      replacement.value = CoverageMode.OPEN
      coverageResponsibleId.value = null
      coverageNote.value = ''
      selectedResponsibleName.value = null
      isTransitionModalOpen.value = false
      resetReasons()
    } else {
      isExpandedTableModalOpen.value = false
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalVue, {
      modalActive: isThisModalVisible.value,
      onClose: close,
      hasHeaderBorder: true,
      hasFooterBorder: true
    }, {
      header: _withCtx(() => [
        _createVNode(ActionModalHeader, {
          "station-details": __props.stationDetails,
          title: __props.release ? 'Liberar vaga' : 'Remover médico'
        }, null, 8, ["station-details", "title"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          (!showShiftList.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createVNode(OutlineButton, {
                  height: "48px",
                  color: "grey",
                  onClick: close,
                  class: "w-full md:w-auto"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancelar ")
                  ]),
                  _: 1
                }),
                _createVNode(FilledButton, {
                  height: "48px",
                  color: "primary",
                  "data-testid": "remove-doctor-view-shifts-button",
                  onClick: handleViewDoctorStations,
                  loading: isLoadingShifts.value,
                  disabled: !isViewShiftsButtonEnabled.value,
                  class: "w-full md:w-auto"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ver plantões ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (totalShiftsCount.value > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createVNode(OutlineButton, {
                        height: "48px",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (showShiftList.value = false)),
                        color: "grey",
                        class: "w-full md:w-auto"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Voltar ")
                        ]),
                        _: 1
                      }),
                      _createVNode(OutlineButton, {
                        height: "48px",
                        color: "negative",
                        class: "!border-negative w-full md:w-auto",
                        "data-testid": "remove-doctor-confirm-button",
                        disabled: isSubmitBlocked.value,
                        onClick: submitRemoveDoctor,
                        loading: isLoadingSubmit.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(confirmLabel.value), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createVNode(FilledButton, {
                        height: "48px",
                        color: "primary",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (showShiftList.value = false)),
                        class: "w-full md:w-auto"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Voltar ")
                        ]),
                        _: 1
                      })
                    ]))
              ], 64))
        ])
      ]),
      default: _withCtx(() => [
        (isLoadingSubmit.value)
          ? (_openBlock(), _createBlock(Spinner, {
              key: 0,
              color: "primary",
              size: "5rem",
              width: "0.5rem",
              class: "absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-50"
            }))
          : _createCommentVNode("", true),
        (!showShiftList.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (__props.release)
                  ? (_openBlock(), _createBlock(UnidentifiedCoverageCard, {
                      key: 0,
                      class: "md:max-w-xs w-full",
                      "responsible-name": originCoverage.value.responsibleName,
                      note: originCoverage.value.note,
                      compact: ""
                    }, null, 8, ["responsible-name", "note"]))
                  : _createCommentVNode("", true),
                (__props.stationDetails?.doctorStation && !__props.release)
                  ? (_openBlock(), _createBlock(CardDutyWithDoctor, {
                      key: 1,
                      formation: __props.stationDetails.doctorStation.dsPaymentDoctorFormation?.name || '',
                      team: __props.stationDetails.doctorStation.ourTeam ? 'Interno' : 'Externo',
                      position: __props.stationDetails.position?.name || '',
                      shift: __props.stationDetails.shift?.name || '',
                      dutyLabel: __props.stationDetails.doctorStation.type || '',
                      doctorName: __props.stationDetails.doctorStation.doctor?.mainCrm?.name || 'Nome não encontrado',
                      doctorCrm: `${__props.stationDetails.doctorStation.doctor?.mainCrm?.number || ''}-${
            __props.stationDetails.doctorStation.doctor?.mainCrm?.uf || ''
          }`,
                      active: false,
                      scheduleId: __props.stationDetails.schedule?.id,
                      npsScore: __props.stationDetails?.doctorNpsScore?.npsScore,
                      avatarUrl: __props.stationDetails.doctorStation.doctor?.user?.avatarUrl
                    }, null, 8, ["formation", "team", "position", "shift", "dutyLabel", "doctorName", "doctorCrm", "scheduleId", "npsScore", "avatarUrl"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("span", null, _toDisplayString(__props.stationDetails?.schedule?.healthUnit?.company?.name || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("span", null, _toDisplayString(__props.stationDetails?.schedule?.name || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", null, _toDisplayString(__props.stationDetails?.schedule?.healthUnit?.name || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", null, _toDisplayString(__props.stationDetails?.position?.name || 'N/A'), 1)
                  ])
                ])
              ]),
              (!__props.release && scheduleSupports.value && (allowUnidentified.value || _unref(unidentifiedLocked)))
                ? (_openBlock(), _createBlock(CoverageModeSelector, {
                    key: 0,
                    modelValue: replacement.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((replacement).value = $event)),
                    variant: "cards",
                    label: "O que fica no lugar?",
                    options: [_unref(CoverageMode).OPEN, _unref(CoverageMode).UNIDENTIFIED],
                    "allow-unidentified": allowUnidentified.value,
                    "unidentified-locked": _unref(unidentifiedLocked),
                    "can-open-schedule-settings": _unref(canOpenScheduleSettings),
                    onOpenScheduleSettings: _cache[1] || (_cache[1] = ($event: any) => (_unref(openScheduleSettings)(close)))
                  }, null, 8, ["modelValue", "options", "allow-unidentified", "unidentified-locked", "can-open-schedule-settings"]))
                : _createCommentVNode("", true),
              (!__props.release && replacement.value === _unref(CoverageMode).UNIDENTIFIED)
                ? (_openBlock(), _createBlock(CoverageResponsibleField, {
                    key: 1,
                    "responsible-id": coverageResponsibleId.value,
                    "onUpdate:responsibleId": _cache[2] || (_cache[2] = ($event: any) => ((coverageResponsibleId).value = $event)),
                    note: coverageNote.value,
                    "onUpdate:note": _cache[3] || (_cache[3] = ($event: any) => ((coverageNote).value = $event)),
                    "health-unit-id": props.stationDetails?.schedule?.healthUnit?.id ?? null,
                    "health-unit-name": props.stationDetails?.schedule?.healthUnit?.name ?? null,
                    "onUpdate:responsibleName": _cache[4] || (_cache[4] = ($event: any) => (selectedResponsibleName.value = $event))
                  }, null, 8, ["responsible-id", "note", "health-unit-id", "health-unit-name"]))
                : _createCommentVNode("", true),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_v_autocomplete, {
                    modelValue: selectedRecurrence.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedRecurrence).value = $event)),
                    items: _unref(removeRecurrenceOptions),
                    label: "Recorrência da remoção",
                    variant: "outlined",
                    color: "primary20",
                    density: "comfortable",
                    "item-title": "title",
                    "item-value": "value",
                    loading: isLoading.value,
                    "hide-details": ""
                  }, null, 8, ["modelValue", "items", "loading"]),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(recurrenceDescription.value), 1)
                ]),
                (selectedRecurrence.value !== 'once')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (selectedRecurrence.value === 'abcde')
                        ? (_openBlock(), _createBlock(OptionSelect, {
                            key: 0,
                            label: "Selecione as semanas do mês a serem removidas",
                            options: _unref(weekOptions),
                            modelValue: selectedWeeks.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedWeeks).value = $event)),
                            multiple: ""
                          }, null, 8, ["options", "modelValue"]))
                        : _createCommentVNode("", true),
                      _createVNode(OptionSelect, {
                        label: "Selecione os dias da semana a serem removidos",
                        options: _unref(dayOptions),
                        modelValue: selectedDay.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedDay).value = $event)),
                        multiple: ""
                      }, null, 8, ["options", "modelValue"]),
                      _createElementVNode("div", null, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(removePeriodicityOptions), (opt) => {
                            return (_openBlock(), _createBlock(SelectableCard, {
                              key: opt.value,
                              title: opt.title,
                              description: opt.description,
                              selected: selectedPeriodicity.value === opt.value,
                              onClick: ($event: any) => (selectedPeriodicity.value = opt.value),
                              class: "!flex"
                            }, null, 8, ["title", "description", "selected", "onClick"]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_v_icon, {
                            icon: _unref(mdiInformationOutline),
                            class: "text-primary w-5 h-5 mt-0.5 shrink-0"
                          }, null, 8, ["icon"]),
                          _createElementVNode("p", _hoisted_20, [
                            _createTextVNode(" A abrangência selecionada será aplicada a partir da data deste plantão "),
                            _createElementVNode("span", _hoisted_21, "(" + _toDisplayString(formattedStartDate.value) + ")", 1),
                            _createTextVNode(" até o limite definido na opção abaixo. ")
                          ])
                        ])
                      ]),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", {
                              class: _normalizeClass(selectedRepetition.value === 'personalized' ? 'w-3/4' : 'w-full')
                            }, [
                              _createVNode(_component_v_autocomplete, {
                                modelValue: selectedRepetition.value,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedRepetition).value = $event)),
                                items: _unref(repetition),
                                label: "Se repete até",
                                variant: "outlined",
                                color: "primary20",
                                density: "comfortable",
                                "item-title": "title",
                                "item-value": "value",
                                loading: isLoading.value,
                                "hide-details": ""
                              }, null, 8, ["modelValue", "items", "loading"])
                            ], 2),
                            (selectedRepetition.value === 'personalized')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _createVNode(_unref(DatePicker), {
                                    modelValue: startDate.value,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((startDate).value = $event)),
                                    "max-date": 
                    props.stationDetails?.schedule?.endDate
                      ? new Date(props.stationDetails.schedule.endDate)
                      : null
                  ,
                                    "initial-page": _unref(initialPage),
                                    locale: "pt-BR",
                                    masks: { input: 'DD/MM/YYYY' }
                                  }, {
                                    default: _withCtx(({ inputValue, inputEvents }) => [
                                      _createVNode(_component_v_text_field, _mergeProps({
                                        label: "Data final",
                                        "model-value": inputValue
                                      }, _toHandlers(inputEvents), {
                                        color: "primary20",
                                        variant: "outlined",
                                        density: "comfortable",
                                        "prepend-inner-icon": _unref(mdiCalendar),
                                        readonly: "",
                                        "hide-details": ""
                                      }), null, 16, ["model-value", "prepend-inner-icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "max-date", "initial-page"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
              (totalShiftsCount.value > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("p", _hoisted_26, _toDisplayString(summaryText.value), 1),
                    (coveragePlan.value.hasContract && coveragePlan.value.counts.BLOCKED > 0)
                      ? (_openBlock(), _createBlock(CoveragePreviewSummary, {
                          key: 0,
                          plan: coveragePlan.value
                        }, null, 8, ["plan"]))
                      : _createCommentVNode("", true),
                    _createVNode(ManagementDoctorTable, {
                      headers: previewHeaders.value,
                      items: limitedFormattedShifts.value,
                      expandable: "",
                      onExpand: _unref(handleExpandTable)
                    }, null, 8, ["headers", "items", "onExpand"]),
                    (_unref(reasonFields).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reasonFields), (field, index) => {
                            return (_openBlock(), _createBlock(ChangeReasonField, _mergeProps({
                              key: field.kind,
                              modelValue: _unref(reasonValues)[field.kind],
                              "onUpdate:modelValue": ($event: any) => ((_unref(reasonValues)[field.kind]) = $event)
                            }, field, {
                              "show-errors": _unref(showReasonErrors),
                              "scope-note": index === _unref(reasonFields).length - 1 ? reasonScopeNote.value : ''
                            }), null, 16, ["modelValue", "onUpdate:modelValue", "show-errors", "scope-note"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(_component_v_icon, {
                      class: "w-24 h-24 mb-4",
                      icon: _unref(mdiAlertCircleOutline),
                      color: '#DA1E28'
                    }, null, 8, ["icon"]),
                    _hoisted_29
                  ]))
            ]))
      ]),
      _: 1
    }, 8, ["modalActive"]),
    _createVNode(ExpandedTableModal, {
      showModal: isExpandedTableModalOpen.value,
      headers: previewHeaders.value,
      items: formattedShifts.value,
      mode: 'remove',
      title: __props.release ? 'Liberar vaga' : null,
      "conflict-count": conflictShiftsCount.value,
      "open-count": coveragePlan.value.hasContract ? coveragePlan.value.counts.OPEN : openShiftsCount.value,
      "closed-count": coveragePlan.value.hasContract ? coveragePlan.value.counts.DOCTOR : closedShiftsCount.value,
      "unidentified-count": 
      coveragePlan.value.hasContract ? coveragePlan.value.counts.UNIDENTIFIED : unregisteredShiftsCount.value
    ,
      "blocked-count": coveragePlan.value.hasContract ? coveragePlan.value.counts.BLOCKED : null,
      "total-count": totalShiftsCount.value,
      onClose: _unref(handleCloseExpandedTable)
    }, null, 8, ["showModal", "headers", "items", "title", "conflict-count", "open-count", "closed-count", "unidentified-count", "blocked-count", "total-count", "onClose"]),
    _createVNode(CoverageTransitionConfirmModal, {
      "show-modal": isTransitionModalOpen.value,
      summary: transitionSummary.value,
      "responsible-name": selectedResponsibleName.value,
      loading: isLoadingSubmit.value,
      onConfirm: handleTransitionConfirm,
      onCancel: _cache[12] || (_cache[12] = ($event: any) => (isTransitionModalOpen.value = false))
    }, null, 8, ["show-modal", "summary", "responsible-name", "loading"])
  ], 64))
}
}

})